export default "__VITE_ASSET__DPVryD7C__"